"use client"

import { formatNumber } from "@/lib/utils"

export interface IndicatorTableColumn<T> {
  key: keyof T
  label: string
}

export default function IndicatorTable<T extends { date: string }>({
  data,
  columns,
}: {
  data: T[]
  columns: IndicatorTableColumn<T>[]
}) {
  const sorted = [...data].sort((a, b) => b.date.localeCompare(a.date)) // 최신 날짜가 위로

  return (
    <div className="h-[240px] overflow-y-auto rounded-md ring-1 ring-zinc-800">
      <table className="w-full text-xs">
        <thead className="sticky top-0 bg-zinc-900">
          <tr>
            <th className="px-2 py-1.5 text-left font-medium text-zinc-400">날짜</th>
            {columns.map((c) => (
              <th key={String(c.key)} className="px-2 py-1.5 text-right font-medium text-zinc-400">
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sorted.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 1} className="px-2 py-4 text-center text-zinc-500">
                데이터 없음
              </td>
            </tr>
          ) : (
            sorted.map((row) => (
              <tr key={row.date} className="border-t border-zinc-800">
                <td className="px-2 py-1.5 text-zinc-300">{row.date}</td>
                {columns.map((c) => (
                  <td key={String(c.key)} className="px-2 py-1.5 text-right tabular-nums text-zinc-200">
                    {formatNumber(row[c.key])}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
